module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Détail utilisateur\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff9aa5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/show.vue
// module id = 107
// module chunks = 0